import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref, watch } from 'vue'
import { IEvento } from '../../../common/types/Evento'
import ComponentAuthGuard from '@/components/ComponentAuthGuard.vue'
import CardConfirma from '@/components/CardConfirma.vue'
import { criarPresenca, irmaoPodeVerPresenca, obterCorDoEvento } from '../../shareds/sharedsEvento'
import { agenda, authModule, userModule, alert } from '@/store'
import { formatarData } from '../../shareds/formatadores'
import EventoService from '@/services/EventoService'
import { adminPotenciaGuard } from '@/shareds/sharedsPotencia'
import { adminLojaGuard } from '@/shareds/sharedsLoja'
import IconeDoEvento from '@/components/IconeDoEvento.vue'
import { InputPresenca } from '../../../common/types/Presenca'
import PresencaService from '@/services/PresencaService'
import BotoesDePresenca from './BotoesDePresenca.vue'
import copyToClipboard from 'copy-to-clipboard'
import { dataEHoraDoEvento, eventoDeLoja } from '../../../common/shareds/sharedEvento'
import dayjs from 'dayjs'
import TextoComLinks from '@/components/TextoComLinks.vue'


const __default__ = {
	model: {
		prop: 'mostra',
	},
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'DialogoEvento',
  props: {
	mostra: { default: false, type: Boolean },
	evento: { type: Object as PropType<IEvento>, required: true },
},
  emits: ["input", "exclusao"],
  setup(__props, { emit }: { emit: ({
	(e: 'input', mostra: boolean): void
	(e: 'exclusao', evento: IEvento): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const dialogoExclusao = ref(false)
const excluindo = ref(false)

const presenca = ref<InputPresenca | null>(null)
const buscandoPresenca = ref(true)

const requires = computed(() => {
	switch (props.evento.tipoDaSessao.abreviacao) {
		case 'FDJ':
		case 'DEMOL':
			const { currentUser } = userModule
			if (currentUser && currentUser.role !== 'Visitante' && currentUser.secretarioDeInformatica) return true
	}
	switch (props.evento.tipoDaSessao.tipoDaEntidade) {
		case 'somar': return ['admin']
		case 'potencia': return ['admin', adminPotenciaGuard(props.evento.entidade._id)]
		case 'loja': return ['admin', adminLojaGuard(props.evento.entidade._id)]
	}
})

const passouDaData = computed(() => dayjs().diff(dataEHoraDoEvento(props.evento), 'hours') >= 12)

const mostraPresenca = computed(() => irmaoPodeVerPresenca(props.evento, userModule.currentUser))

async function excluirEvento() {
	try {
		excluindo.value = true
		await EventoService.remove(props.evento._id)
	} catch (error) {
		alert.setError(error)
	} finally {
		excluindo.value = false
		dialogoExclusao.value = false
		emit('exclusao', props.evento)
		emit('input', false)
	}
}

function copiarLink(){
	const copiado = copyToClipboard(`${window.location.origin}/evento/${props.evento._id}`)
	if (copiado) alert.setSuccess('Copiado com sucesso')
}

async function buscarPresenca() {
	const usuario = userModule.currentUser
	if (!usuario) return
	try {
		buscandoPresenca.value = true
		const presencaDoIrmao = usuario.role !== 'Visitante'
			? await PresencaService.getByEventoEIrmao(props.evento._id, usuario._id)
			: null

		presenca.value = presencaDoIrmao
			? {
				...presencaDoIrmao,
				irmao: presencaDoIrmao.irmao._id,
			}
			: criarPresenca({
				evento: props.evento._id,
				irmao: usuario._id,
				intencoes: [],
			})
	} catch (error) {
		alert.setError(error)
	} finally {
		buscandoPresenca.value = false
	}
}

watch(() => props.mostra, (mostra) => {
	if (mostra) {
		buscarPresenca()
	}
}, { immediate: true })

return { __sfc: true,props, emit, dialogoExclusao, excluindo, presenca, buscandoPresenca, requires, passouDaData, mostraPresenca, excluirEvento, copiarLink, buscarPresenca, ComponentAuthGuard, CardConfirma, obterCorDoEvento, agenda, formatarData, IconeDoEvento, BotoesDePresenca, eventoDeLoja, TextoComLinks }
}

})